import { Link } from "react-router-dom";
import {
  ArrowUpRight,
  ArrowRight,
  ShieldCheck,
  Zap,
  Network,
  FileCheck2,
  Wallet,
  Briefcase,
  Building2,
  Home as HomeIcon,
  LineChart,
  Stethoscope,
  TrendingUp,
} from "lucide-react";
import StatsRow from "../components/StatsCounter";
import EMICalculator from "../components/EMICalculator";
import FAQSection from "../components/FAQ";
import {
  services,
  whyChoose,
  partners,
  stats,
  company,
} from "../lib/data";
import useSEO from "../lib/seo";

const iconMap = {
  Wallet,
  Briefcase,
  Building2,
  Home: HomeIcon,
  ShieldCheck,
  LineChart,
  Stethoscope,
  TrendingUp,
};

const whyIcons = [Network, ShieldCheck, FileCheck2, Zap, Briefcase, Wallet];

export default function Home() {
  useSEO({
    title:
      "Personal, Home, Business & Mortgage Loans from India's Leading Banks",
    description:
      "DVP DIGI WORLD — Chennai's trusted unified financial partner. Personal, Home, Business, Mortgage (LAP), Doctor & Professional loans, Insurance, Mutual Funds and SIPs. ₹150 Cr+ disbursed. 1,000+ happy customers.",
    path: "/",
  });
  return (
    <div data-testid="page-home">
      {/* HERO */}
      <section className="relative overflow-hidden border-b border-white/5">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1771432998363-0b78f8ee339a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBidWlsZGluZyUyMHR3aWxpZ2h0fGVufDB8fHx8MTc3NjQ0NzkyN3ww&ixlib=rb-4.1.0&q=85')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/90 via-[#0a0a0a]/75 to-[#0a0a0a]" />
        <div className="absolute -top-40 -left-40 h-96 w-96 bg-[#dc2626]/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -right-40 h-[500px] w-[500px] bg-[#1d4ed8]/20 rounded-full blur-3xl" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-20 sm:pt-32 sm:pb-36">
          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 border border-white/15 bg-white/5 backdrop-blur-sm px-3 py-1.5 rounded-full text-[10px] sm:text-xs text-neutral-300 tracking-[0.2em] uppercase font-mono">
              <span className="h-1.5 w-1.5 rounded-full bg-[#dc2626] animate-pulse" />
              Unified Financial Partner
            </div>
            <h1 className="font-display font-bold text-white mt-5 text-4xl sm:text-6xl lg:text-7xl tracking-tighter leading-[1.05] sm:leading-[0.95]">
              Get the right loan <br />
              from <span className="text-neutral-400">India's</span>{" "}
              <span className="text-[#dc2626]">Leading</span>
              <br />
              Banks.
            </h1>
            <p className="mt-5 text-base sm:text-xl text-neutral-300 max-w-2xl leading-relaxed">
              DVP DIGI WORLD connects individuals, SMEs and corporates to the
              right credit, protection and financial solutions through a trusted
              network of leading banks, NBFCs and financial institutions.
            </p>
            <div className="mt-8 sm:mt-10 flex flex-wrap items-center gap-3 sm:gap-4">
              <Link
                to="/request-access"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-2 bg-[#dc2626] hover:bg-[#ef4444] text-white px-5 sm:px-6 py-3.5 sm:py-4 text-sm sm:text-base font-semibold transition-colors"
              >
                Get Started
                <ArrowUpRight className="h-5 w-5" />
              </Link>
              <Link
                to="/request-access"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 border border-white/20 hover:bg-white/5 text-white px-5 sm:px-6 py-3.5 sm:py-4 text-sm sm:text-base font-semibold transition-colors"
              >
                Request Access
                <ArrowRight className="h-5 w-5" />
              </Link>
            </div>

            <div className="mt-10 sm:mt-14 grid grid-cols-2 sm:grid-cols-4 gap-5 sm:gap-6 max-w-3xl">
              <div>
                <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-neutral-500 font-mono">
                  Disbursed
                </div>
                <div className="mt-1 text-xl sm:text-2xl font-display font-bold text-white">
                  ₹150 Cr+
                </div>
              </div>
              <div>
                <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-neutral-500 font-mono">
                  Customers
                </div>
                <div className="mt-1 text-xl sm:text-2xl font-display font-bold text-white">
                  1,000+
                </div>
              </div>
              <div>
                <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-neutral-500 font-mono">
                  Cities
                </div>
                <div className="mt-1 text-xl sm:text-2xl font-display font-bold text-white">
                  20+
                </div>
              </div>
              <div>
                <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-neutral-500 font-mono">
                  Base
                </div>
                <div className="mt-1 text-xl sm:text-2xl font-display font-bold text-white">
                  Chennai
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PARTNERS MARQUEE */}
      <section className="border-b border-white/5 bg-[#0f0f0f] py-10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 text-[10px] sm:text-xs uppercase tracking-[0.3em] text-neutral-500 font-mono">
          Trusted lender &amp; institutional network
        </div>
        <div className="relative">
          <div className="flex gap-12 sm:gap-16 animate-marquee whitespace-nowrap items-center">
            {[...partners, ...partners].map((p, i) => (
              <div
                key={i}
                className="flex items-center justify-center h-12 sm:h-14 flex-shrink-0"
                title={p.name}
              >
                <img
                  src={p.logo}
                  alt={p.name}
                  loading="lazy"
                  onError={(e) => {
                    const span = document.createElement("span");
                    span.className =
                      "text-neutral-400 font-display font-semibold text-lg sm:text-xl tracking-tight";
                    span.textContent = p.name;
                    e.currentTarget.replaceWith(span);
                  }}
                  className="h-full w-auto max-w-[180px] object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-16 sm:py-24 lg:py-32 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
            <div className="max-w-2xl">
              <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#dc2626]">
                What We Offer
              </div>
              <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-6xl tracking-tighter text-white">
                Solutions tailored for <br />
                <span className="text-neutral-500">retail, SME &amp; corporate.</span>
              </h2>
            </div>
            <p className="text-neutral-400 max-w-md leading-relaxed">
              From personal finance needs to structured business funding, DVP
              DIGI WORLD offers end-to-end support across multiple product
              categories.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10 rounded-xl overflow-hidden">
            {services.map((s, i) => {
              const Icon = iconMap[s.icon] || ShieldCheck;
              return (
                <Link
                  key={s.slug}
                  to={`/services#${s.slug}`}
                  data-testid={`home-service-${s.slug}`}
                  className="group relative bg-[#0a0a0a] p-8 hover:bg-[#121212] transition-colors"
                >
                  <div className="flex items-start justify-between mb-6">
                    <div className="h-12 w-12 rounded-lg bg-[#dc2626]/10 border border-[#dc2626]/20 flex items-center justify-center text-[#dc2626] group-hover:bg-[#dc2626] group-hover:text-white transition-colors">
                      <Icon className="h-6 w-6" />
                    </div>
                    <span className="font-mono text-xs text-neutral-500">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-xl text-white mb-2">
                    {s.title}
                  </h3>
                  <p className="text-neutral-400 text-sm leading-relaxed">
                    {s.short}
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm text-neutral-300 group-hover:text-white font-medium">
                    Learn more
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="py-16 sm:py-24 lg:py-32 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-12">
            <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#1d4ed8]">
              Why Us?
            </div>
            <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-white">
              Numbers that speak for themselves.
            </h2>
          </div>
          <StatsRow items={stats} />
        </div>
      </section>

      {/* EMI CALCULATOR */}
      <section className="py-16 sm:py-24 lg:py-32 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
            <div className="max-w-2xl">
              <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#dc2626]">
                Tools
              </div>
              <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-white">
                Plan your EMI in seconds.
              </h2>
            </div>
            <Link
              to="/tools"
              data-testid="home-tools-link"
              className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white border border-white/15 hover:border-white/30 px-4 py-2.5 font-semibold"
            >
              Open full tools <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
          <EMICalculator />
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="py-16 sm:py-24 lg:py-32 border-b border-white/5 bg-[#0d0d0d]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-14">
            <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#dc2626]">
              Why DVP DIGI WORLD
            </div>
            <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-6xl tracking-tighter text-white">
              Dependable financial solutions with{" "}
              <span className="text-[#1d4ed8]">speed, transparency</span> and
              strong execution.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((w, i) => {
              const Icon = whyIcons[i % whyIcons.length];
              return (
                <div
                  key={i}
                  data-testid={`why-item-${i}`}
                  className="group relative bg-[#121212] border border-white/10 rounded-xl p-8 hover:border-white/20 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="h-11 w-11 rounded-lg bg-white/5 flex items-center justify-center text-[#dc2626] mb-5 group-hover:bg-[#dc2626] group-hover:text-white transition-colors">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="font-display font-semibold text-lg text-white mb-2">
                    {w.title}
                  </h3>
                  <p className="text-neutral-400 text-sm leading-relaxed">
                    {w.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* FAQ PREVIEW */}
      <section className="py-16 sm:py-24 lg:py-32 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#1d4ed8]">
              FAQ
            </div>
            <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-white">
              Common questions, <br />
              <span className="text-neutral-500">clear answers.</span>
            </h2>
            <p className="mt-5 text-neutral-400 leading-relaxed">
              Quick answers to the most common questions about loan processing,
              eligibility, documentation and repayment.
            </p>
            <Link
              to="/faq"
              data-testid="home-faq-link"
              className="mt-8 inline-flex items-center gap-2 bg-[#dc2626] hover:bg-[#ef4444] text-white px-5 py-3 font-semibold"
            >
              See all FAQs <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
          <div className="lg:col-span-8 border border-white/10 rounded-xl bg-[#0f0f0f] px-6 sm:px-10">
            <FAQSection limit={6} />
          </div>
        </div>
      </section>

      {/* CTA BAND */}
      <section className="py-14 sm:py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0f0f0f] p-6 sm:p-10 lg:p-16">
            <div className="absolute -top-20 -right-20 h-80 w-80 rounded-full bg-[#dc2626]/20 blur-3xl" />
            <div className="absolute -bottom-20 -left-20 h-80 w-80 rounded-full bg-[#1d4ed8]/20 blur-3xl" />
            <div className="relative flex flex-col lg:flex-row lg:items-end justify-between gap-8">
              <div className="max-w-2xl">
                <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tighter text-white">
                  Speak to our team to find the right financial solution.
                </h2>
                <p className="mt-5 text-neutral-300 leading-relaxed text-lg">
                  Personal, business or corporate — we'll connect you with
                  suitable lending and insurance partners through a single
                  trusted point of contact.
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-3">
                <Link
                  to="/request-access"
                  data-testid="home-cta-band-primary"
                  className="inline-flex items-center gap-2 bg-[#dc2626] hover:bg-[#ef4444] text-white px-6 py-4 font-semibold"
                >
                  Apply for Access <ArrowUpRight className="h-5 w-5" />
                </Link>
                <a
                  href={company.phoneHref}
                  data-testid="home-cta-band-phone"
                  className="inline-flex items-center gap-2 border border-white/20 hover:bg-white/5 text-white px-6 py-4 font-semibold font-mono"
                >
                  {company.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
